import React from 'react';
import OpportunityForm from '../components/opportunities/OpportunityForm';

const CreateOpportunity = () => {
  return <OpportunityForm isEdit={false} />;
};

export default CreateOpportunity;
